import {
  Component,
  Input,
  OnInit,
  input,
  output,
  ChangeDetectionStrategy,
} from "@angular/core";
import { SelectItem } from "primeng/api";
import { rateStatus } from "app/rate/rate-status.const";
import { Bind } from "primeng/bind";
import { Select } from "primeng/select";
import { SelectedChipsComponent } from "../../chip/selected-chips.component";
import { Checkbox } from "primeng/checkbox";
import { FormsModule } from "@angular/forms";

@Component({
  selector: "app-rate-status-multiselect",
  templateUrl: "./rate-status-multiselect.component.html",
  styleUrls: ["./rate-status-multiselect.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [Bind, Select, Checkbox, FormsModule, SelectedChipsComponent],
})
export class RateStatusMultiselectComponent implements OnInit {
  public readonly statusChange = output<string[]>();
  @Input() public statuses;
  public readonly disabled = input(false);

  public statusList: SelectItem[] = [];

  constructor() {}

  ngOnInit() {
    this.buildStatusList();
  }

  public onStatusChange(statuses: string[]) {
    this.statusChange.emit(statuses);
  }

  public readonly chipLabel = (status: string): string =>
    this.getStatusLabel(status);

  public removeStatus(status: string) {
    this.statuses = (this.statuses ?? []).filter(
      (item: string) => item !== status,
    );
    this.onStatusChange(this.statuses);
  }

  public isSelected(status: string): boolean {
    return (this.statuses ?? []).includes(status);
  }

  public getStatusLabel(status: string): string {
    return this.statusList.find((item) => item.value === status)?.label ?? "";
  }

  private buildStatusList() {
    Object.keys(rateStatus).map((key) => {
      this.statusList.push({
        label:
          String(rateStatus[key]).charAt(0).toUpperCase() +
          String(rateStatus[key]).slice(1),
        value: key,
      });
    });
  }
}
